/**
 * Stage 5E.2 Phase 3 — shared PoweredByOrdly attribution.
 *
 * Reads the canonical ``attribution.show_powered_by_ordly`` from the
 * shared BrandProvider. The flag is server-driven (contract §8); the
 * component is the only render path for the attribution mark — it
 * cannot be hidden or configured by individual pages.
 */
import React from "react";
import { useBrand } from "./BrandProvider";

export default function PoweredByOrdly({
    className,
    "data-testid": testId,
}) {
    const { attribution } = useBrand();
    if (!attribution?.show_powered_by_ordly) {
        return null;
    }
    return (
        <p
            className={className || "powered-by-ordly"}
            data-testid={testId || "powered-by-ordly"}
        >
            Powered by Ordly
        </p>
    );
}
